<template>
  <div class="relative min-w-[360px] min-h-[320px]">
    <div
      class="absolute right-2 top-0 w-10 h-5 z-20 pointer-events-none flex"
      :style="{
        background: backgroundColor && backgroundColor !== 'transparent' ? backgroundColor : '#F0F5F8'
      }">
      <Download :color="textColor" class="ml-auto" />
    </div>

    <apexchart :id="chartid" :options="chart_options" :series="chartdata[0].data" :height="height * 18" />
  </div>
</template>

<script>
import { Download } from "lucide-vue-next"

export default {
  name: "Chart",
  components: {
    Download
  },
  props: {
    height: null,
    textColor: null,
    showDataLabels: null,
    backgroundColor: null,
    chartid: {
      type: String,
      default: "chartName"
    },
    chartdata: {
      type: Array,
      default: () => [2, 2, 3]
    },
    labels: {
      type: Array,
      default: () => []
    },
    hasLegend: {
      type: Boolean,
      default: true
    },

    showZoom: {
      type: Boolean,
      default: true
    },
    graphObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart_options: {},
      formattedLabels: []
    }
  },
  computed: {
    changed() {
      return this.$store.state.ui.darkMode
    },
    isChecked() {
      return this.hasLegend
    }
  },
  watch: {
    changed() {
      this.generateColors(this.changed)
    },
    height() {
      this.createChart()
    }
  },
  created() {
    this.formattedLabels = this.chartdata.map((point) => this.formatPoint(point))
    this.createChart()
  },
  methods: {
    formatPoint(datapoint) {
      return this.$utils.truncateNumber(datapoint)
    },
    createChart() {
      this.chart_options = {
        title: {
          margin: 20,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          text: this.graphObj.name,
          align: "center"
        },
        chart: {
          foreColor: this.textColor,
          height: this.height * 18,
          background: this.$store.state.ui.darkMode ? "#2b3c44" : "transparent",
          type: "pie",
          zoom: {
            enabled: this.showZoom
          },
          toolbar: {
            show: true,
            export: {
              csv: {
                filename: this.graphObj.name
              },
              svg: {
                filename: this.graphObj.name
              },
              png: {
                filename: this.graphObj.name
              }
            },
            autoSelected: "zoom"
          }
        },
        dataLabels: {
          enabled: this.showDataLabels
        },
        labels: this.labels,
        legend: {
          show: this.isChecked,
          position: "bottom",
          labels: {
            colors: this.$store.state.ui.darkMode ? "white" : this.textColor
          }
        }
      }
    },
    generateColors(isDarkMode) {
      this.chart_options = {
        dataLabels: {
          enabled: this.showDataLabels
        },
        chart: {
          background: this.$store.state.ui.darkMode ? "#2b3c44" : "transparent"
        },
        title: {
          style: {
            color: this.$store.state.ui.darkMode ? "#FFF" : "#000"
          }
        },
        legend: {
          labels: {
            colors: isDarkMode ? "white" : this.textColor
          }
        }
      }
    }
  }
}
</script>
